/* istanbul ignore file */
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import isEmpty from 'lodash/isEmpty';
import LocalStorage from 'yoda-core-components/lib/helpers/LocalStorage/LocalStorage';
import {
    selectFeatureFlags,
    selectPreferencesUrgencyApiUrl,
} from '../../selectors/ContextSelector';
import getUrgencyStatementsAction from '../../actions/UrgencyMessagingAction';
import { isGalleryPage } from '../../helpers/Utils/pageType';

const useProductCartridgeEffect = (
    productCartridgeList,
    enableUrgencyMessagingOnATC,
    dispatch,
    pathname,
    slotId,
    cartridgeRef,
    fireEnsightenEvent
) => {
    const URGENCY_API_URL = useSelector(selectPreferencesUrgencyApiUrl);
    const { pdpBreadCrumbzScrollTop = true } = useSelector(selectFeatureFlags);

    const removeLocalStorageData = (key, value) => {
        try {
            LocalStorage.removeData(key, value);
        } catch (error) {
            console.error(`Failed to remove data in LocalStorage: ${error}`);
        }
    };

    const fireUrgencyStatementsAction = () => {
        const ppIds = productCartridgeList.map((obj) => obj.id);
        if (enableUrgencyMessagingOnATC && ppIds.length > 0) {
            dispatch(
                getUrgencyStatementsAction({
                    ppid: ppIds,
                    apiURL: URGENCY_API_URL,
                })
            );
        }
    };

    const handleGalleryScroll = () => {
        const scrollToCartridgeVal = LocalStorage.getData('scrollToCartridge', true);
        const parsedJson = scrollToCartridgeVal && JSON.parse(scrollToCartridgeVal);
        const galleryScrollToVal =
            parsedJson?.val && parsedJson?.key === window.location.href ? parsedJson?.val : {};
        if (!isEmpty(parsedJson)) {
            const pdpBreadCrumbsClickData = LocalStorage.getData('pdpBreadCrumbsClick');
            const isScrollTop = pdpBreadCrumbsClickData && pdpBreadCrumbzScrollTop;
            if (!isEmpty(galleryScrollToVal) && !isScrollTop) {
                const { galleryScrollTo } = galleryScrollToVal;
                if (
                    /* adding replace as few times when we came back from pdp to plp
                    same data populating same slot name with different number */
                    galleryScrollTo?.replace(/[0-9]/g, '') === slotId.replace(/[0-9]/g, '')
                ) {
                    cartridgeRef.scrollIntoView({ behaviour: 'smooth' });
                }
            } else if (!__SERVER__) {
                window.scroll({ top: 0, behavior: 'smooth' });
            }
            removeLocalStorageData('scrollToCartridge', true);
            removeLocalStorageData('galleryScrollToOffSet');
            removeLocalStorageData('pdpBreadCrumbsClick');
        }
    };

    useEffect(() => {
        if (productCartridgeList?.length > 0) {
            fireEnsightenEvent(productCartridgeList);
            fireUrgencyStatementsAction();
        }

        if (isGalleryPage(pathname)) {
            handleGalleryScroll();
        }
    }, []);
};

export default useProductCartridgeEffect;
